let notify;

export default {
  data() {
    return {
      productSaved: false,
      uploadedImageCount: 0,
      data: null,
      show: false,
      type: null,
      message: "",
      subMessage: "",
      redirection: null,
      fadeTime: 0,
    };
  },

  beforeMount() {
    notify = this;
  },

  mounted() {
    this.$notify.$on("fire", this.notifyCallback);
    this.$notify.$on("close", this.close);
    this.$notify.$on("update", this.update);
    this.$notify.$on("product-image-saved", this.productImageSavedCallback);
    this.$notify.$on("product-saved", this.productSavedCallback);
  },

  beforeDestroy() {
    this.$notify.$off("fire", this.notifyCallback);
    this.$notify.$off("close", this.close);
    this.$notify.$off("update", this.update);
    this.$notify.$off("product-image-saved", this.productImageSavedCallback);
    this.$notify.$off("product-saved", this.productSavedCallback);
  },

  methods: {
    checkIfProductSaved,
    productImageSavedCallback,
    productSavedCallback,
    notifyCallback,
    update,
    close,
  },
};

function productImageSavedCallback(id) {
  this.uploadedImageCount += 1;
  this.checkIfProductSaved(id);
}

function productSavedCallback(id) {
  this.productSaved = true;
  this.checkIfProductSaved(id);
}

function checkIfProductSaved(id) {
  if (
    this.productSaved &&
    ((this.data && this.uploadedImageCount === this.data.images) || (!this.data && !this.uploadedImageCount))
  ) {
    this.uploadedImageCount = 0; // reset image uploaded count
    let data = {
      message: "Product successfully saved",
      redirection: `/dashboard/products/${id}/edit`,
      type: "success",
      fadeTime: 12000,
    };

    this.$eventBus.$emit("clear-saving-product");
    this.notifyCallback(data);
  }
}

function update(message) {
  this.message = message;
}

function notifyCallback(data) {
  const _self = this;

  _self.data = data.data;
  _self.message = data.message;
  _self.subMessage = data.subMessage;
  _self.redirection = data.redirection;
  _self.type = data.type;
  _self.onClose = data.onClose;
  _self.show = true;

  if (data.fadeTime || _self.fadeTime) {
    let fadeTime = data.fadeTime || _self.fadeTime;

    setTimeout(function () {
      _self.close();
    }, fadeTime);
  }
}

function close() {
  this.show = false;
  if (this.onClose) {
    this.onClose();
  }
}
